module.exports = __webpack_public_path__ + "img/pj_001.b52196bb.webp";